import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "How many players?",
    a: "3–8 players. People Watching is designed for small groups of friends and family — pull up a table and go.",
  },
  {
    q: "How long does a game last?",
    a: "As long as you want it to. A quick round at the pub or a longer session on holiday — People Watching is designed to flex to your setting.",
  },
  {
    q: "Can children play?",
    a: "Yes. People Watching is suitable for all ages — friends, couples and families can all play together. The gameplay is warm and observational, not sensitive.",
  },
  {
    q: "Where can we play?",
    a: "Wherever there are people. Airports, pubs, cafés, festivals, cruises, trains and holidays are all ideal. Indoors, outdoors — if humans are nearby, there's a game.",
  },
  {
    q: "Can it be played while travelling?",
    a: "It's genuinely built for it. Airports, train journeys, road trips, cruises and holidays are the game's natural home.",
  },
  {
    q: "Do I need to photograph people?",
    a: "No. You do not need to photograph anyone to play. Playing is purely about spotting — no cameras, no filming, no privacy concerns.",
  },
  {
    q: "What makes People Watching different from other card games?",
    a: "There's no board and no screen. The world around you becomes the game. Every crowd, every venue, every day gives you a different play.",
  },
  {
    q: "What's included in the box?",
    a: "56 cards, including 2 instruction cards inside the deck. Everything you need to play — nothing you don't.",
  },
  {
    q: "How difficult is it to learn?",
    a: "You'll be playing within a minute of opening the box.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="confetti-canvas py-10 md:py-28 relative"
    >
      <div className="max-w-3xl mx-auto px-5 md:px-8 relative z-10">
        <p className="eyebrow mb-4" style={{ color: "var(--pw-yellow)" }}>FAQ</p>
        <h2
          className="font-display font-black leading-[0.95] tracking-tighter mb-10 md:mb-12 text-white"
          style={{ fontSize: "clamp(2rem, 5.5vw, 4rem)" }}
        >
          Everything you might reasonably ask.
        </h2>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-white/15"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display text-lg md:text-xl font-semibold py-5 hover:no-underline text-white">
                <span>{f.q}</span>
              </AccordionTrigger>
              <AccordionContent className="text-white/75 text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
